import gql from "graphql-tag";

export default gql`
  mutation LoginWithCredentials($email: String!, $password: String!, $timeZone: String!) {
    loginWithCredentials(email: $email, password: $password, timeZone: $timeZone) {
      email
      isRecentlyCreatedUser
      accessToken
    }
  }
`;
